var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M8.5 5v1a.5.5 0 0 1-1 0V5a.5.5 0 0 1 1 0M6 5a2 2 0 1 1 4 0h4a2 2 0 1 1 4 0h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm-1.5 6.5V18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-6.5zm15-1.5h-15V7a.5.5 0 0 1 .5-.5h1.063a2 2 0 0 0 3.874 0h4.126a2 2 0 0 0 3.874 0H19a.5.5 0 0 1 .5.5zm-3-4V5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0",
    clipRule: "evenodd"
  })));
};
export default SvgCalendar;